import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ICoeNote } from 'modules/contacts/interfaces/coe-notes.interface';
import { Observable } from 'rxjs';

@Injectable()
export class CoeNotesService {
	servicesUrl = environment.servicesUrl;

	constructor(private httpClient: HttpClient) {}

	getNotes(
		customerId: string,
		limit: string
	): Observable<{ items: ICoeNote[]; total: number }> {
		let queryParams = new HttpParams();

		queryParams = queryParams.append('limit', limit);
		queryParams = queryParams.append('skip', '0');

		return this.httpClient.get<{ items: ICoeNote[]; total: number }>(
			`${this.servicesUrl}/promptuary/customer-annotation/find-by-customer-id/${customerId}`,
			{ params: queryParams }
		);
	}
}
